<app-header></app-header>

<div class="container-fluid" style="width: 80%; min-height: 600px">

    <div class="row mt-4 mb-4">
        <div class="col">
            <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
                <ol class="breadcrumb mb-0 p-0">
                    <li class="breadcrumb-item"><a href="/home">Home</a><span class="separator">/</span></li>
                    <li class="breadcrumb-item"><a href="/punti-erogazione-2">Punti di erogazione 2</a><span class="separator">/</span></li>
                    <li class="breadcrumb-item active" aria-current="page">Dettaglio struttura</li>
                </ol>
            </nav>
        </div>
    </div>

    <div class="row mt-4 mb-4">
        <div class="col d-flex align-items-center gap-2">
            <button mat-button (click)="goBack()">
                <mat-icon>arrow_back</mat-icon> Indietro
            </button>
            <h4 class="mb-0">Dettaglio struttura</h4>
        </div>
    </div>

    @if (caricamento) {
        <mat-card class="p-2" appearance="outlined">
            <mat-card-content>
                <div class="text-center py-4">
                    <mat-spinner diameter="40"></mat-spinner>
                    <p class="mt-2 mb-0">Caricamento...</p>
                </div>
            </mat-card-content>
        </mat-card>
    } @else if (errore) {
        <mat-card class="p-2" appearance="outlined">
            <mat-card-content>
                <p class="text-danger">{{ errore }}</p>
                <button mat-button (click)="goBack()">Torna all'elenco</button>
            </mat-card-content>
        </mat-card>
    } @else if (struttura) {
        <mat-card class="p-2 mb-3" appearance="outlined">
            <mat-card-header>
                <mat-card-title>{{ struttura.denominazione ?? struttura.codice ?? 'Struttura' }}</mat-card-title>
                <mat-card-subtitle>Id: {{ struttura.id }} · Codice: {{ struttura.codice }} @if (struttura.fhirId) { · FHIR: {{ struttura.fhirId }} }</mat-card-subtitle>
            </mat-card-header>
        </mat-card>

        <mat-card class="p-2" appearance="outlined">
            <mat-card-header>
                <mat-card-title>Risorsa FHIR Organization (JSON)</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                @if (fhirJsonFormatted) {
                    <pre class="fhir-json">{{ fhirJsonFormatted }}</pre>
                } @else {
                    <p class="text-muted">Nessun dato FHIR Organization disponibile per questa struttura.</p>
                }
            </mat-card-content>
        </mat-card>
    }
</div>

<app-footer></app-footer>
